<template>
  <div class="header-wrap">
    <div class="tabar" v-if="!title">
      <span
        :class="['item', item.path === active ? 'is-active' : '']"
        v-for="(item, index) in tabs"
        :key="index"
        @click="handleChangeTabar(item.path)"
        >{{ item.name }}</span
      >
    </div>
    <div class="title-wrap" v-else>
      <div class="position-wrap">
        <img
          v-if="showBackIcon"
          src="@/assets/icons/back.png"
          alt="返回"
          class="back-icon"
          @click="handleClickBack"
        />
        <span>{{ title }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { router } from '@/router';
  import { computed } from 'vue';
  import { useUserStore } from '@/store/modules/user';
  import { useRecordStore } from '@/store/modules/record';
  interface TabItem {
    name: string;
    path: string;
  }
  const recordStore = useRecordStore();
  const route = useRoute();
  const userStore = useUserStore();
  const userInfo = computed(() => recordStore.getCurrentRecord || recordStore.getDefaultRecord);

  onMounted(async () => {
    await getUserTab();
  });

  const userTabs = ref([]);

  const title = computed(() => {
    if (route.path === '/createRecord') return route.query.archiveId ? '编辑档案' : '新建档案';
    return route.meta.title;
  });
  const tabs = computed(() => {
    const tabArr = [
      {
        name: '我的',
        path: '/mine',
      },
    ];
    if (userTabs.value.includes('train')) {
      tabArr.splice(0, 0, {
        name: '训练',
        path: '/train',
      });
    }
    if (userTabs.value.includes('check')) {
      tabArr.splice(1, 0, {
        name: '检查',
        path: '/examine',
      });
    }
    return tabArr;
  });
  const showBackIcon = ref(true);
  const active = ref(route.path);
  function handleChangeTabar(path: string) {
    active.value = path;
    router.push(path);
  }
  function handleClickBack() {
    if (route.query.fresh === 'fromCreate') {
      router.push('/mine');
    } else {
      router.back();
    }
  }
  const getUserTab = async () => {
    try {
      const archiveId = userInfo.value?.archiveId;
      if (archiveId) {
        const data = await userStore._getUserTabData(archiveId);
        if (data?.length > 0) {
          userTabs.value = data;
        } else {
          await userStore.logout();
        }
      } else {
       await userStore.logout();
      }
    } catch (error) {
      console.log(error);
    }
  };
  watch(
    () => route.path,
    (value) => {
      active.value = value;
    },
    { deep: true },
  );
  watch(
    () => route.query,
    (value: any) => {
      if (value?.fresh === 'new') {
        showBackIcon.value = false;
      } else {
        showBackIcon.value = true;
      }
    },
    {
      deep: true,
      immediate: true,
    },
  );
</script>

<style scoped lang="less">
  .header-wrap {
    position: relative;
    height: 240px;
    .tabar {
      position: absolute;
      bottom: 60px;
      left: 85px;
      font-size: 50px;
      color: #fff;
      .item {
        margin-right: 80px;
        cursor: pointer;
      }
      .is-active {
        font-size: 80px;
        font-weight: 500;
      }
    }
    .title-wrap {
      position: relative;
      height: 100%;
      font-size: 80px;
      font-weight: 500;
      color: #fff;
      .back-icon {
        transform: translateY(2px);
        width: 43px;
      }
      .position-wrap {
        position: absolute;
        bottom: 60px;
        left: 85px;
        span {
          margin-left: 62px;
        }
      }
    }
  }
</style>
